import { RTimeStamps, StrapiDocument } from '../../General/remote/general';
import { RTopic } from '../../Topic/remote/topic';
import { RFile } from '../../Upload/remote/upload';
import { StrapiQueryOptions } from '../../../utils';
import { RTestimonial } from '../../Testimonial';
import { RInstitution } from '../../Institution';
import { RMarkdownText } from '../../MarkDownText';

interface RUnpopulatesProjectAttributes {
    title: string;
    text_section_0: RMarkdownText | null;
    startDate: string | null;
    endDate: string | null;
    text_section_1: RMarkdownText | null;
    text_section_2: RMarkdownText | null;
}

interface RPopulatedProjectAttributes {
    topics: RTopic[];
    titleImage: RFile | null;
    media: RFile[] | null;
    testimonials: RTestimonial[] | null;
    client: RInstitution;
    partnerCompany: RInstitution | null;
}

type RProject = StrapiDocument &
    RUnpopulatesProjectAttributes &
    RTimeStamps &
    Partial<RPopulatedProjectAttributes>;

// All RPopulatedProjectAttributes except "post", bc we fetch those seperately
type OptionalProjectPopulate = {
    topics: { populate: true };
    titleImage: { populate: true };
    media: { populate: true };
    client: { populate: true };
    partnerCompany: { populate: true };
    testimonials: { populate: true };
};

export enum ProjectPopulation {
    Basic,
    Full
}

type ProjectQueryOptions = Omit<StrapiQueryOptions, 'populate'> & {
    populateVariant: ProjectPopulation;
};

export type { RProject, ProjectQueryOptions, OptionalProjectPopulate };
